import { createRoute, redirect } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { ProviderForm } from '../../../../components/admin/ProviderForm.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/providers/new',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: NewProviderPage,
});

function NewProviderPage() {
  return (
    <div>
      <AdminPageHeader
        title="New provider"
        description="Add a new institution to the master catalogue."
        backTo="/app/admin/providers"
        backLabel="All providers"
      />
      <ProviderForm />
    </div>
  );
}
